module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-sm-center"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('form', {
    staticClass: "shaded",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.processForm.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Your name"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Please add your name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.name.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.name.required) ? _c('span', [_vm._v("Your name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.name.minLength) ? _c('span', [_vm._v("Your name must have at least 4 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Email"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Your email"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.email.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.email.required) ? _c('span', [_vm._v("Email is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.email.email) ? _c('span', [_vm._v("Must be a valid email.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Password"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Your password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.password.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.password.required) ? _c('span', [_vm._v("Please type a password.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.password.minLength) ? _c('span', [_vm._v("Minimum length of 6 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fs-smaller mt-5 mb-1"
  }, [_c('checkbox', {
    staticClass: "d-inline",
    attrs: {
      "name": "terms",
      "value": "true"
    },
    model: {
      value: (_vm.form.hasAcceptTermsConditions),
      callback: function($$v) {
        _vm.$set(_vm.form, "hasAcceptTermsConditions", $$v)
      },
      expression: "form.hasAcceptTermsConditions"
    }
  }), _vm._v("\n                I accept the\n\n                "), _c('span', {
    staticClass: "darker underlined pointer",
    on: {
      "click": _vm.openConditions
    }
  }, [_vm._v("Terms of Service and Privacy Policy")])], 1), _vm._v(" "), _c('input', {
    staticClass: "btn blue widest full",
    attrs: {
      "type": "submit",
      "value": "Sign up free",
      "disabled": _vm.$v.$invalid
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2955e66a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2955e66a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/agent/Step1.vue
// module id = 2589
// module chunks = 0